<template>
  <div>
    <list row-key="id" ref="list" unit="打印日志" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="店铺名称" label-width="105px">
          <el-select v-model="mallToken" @change="onMallChange" placeholder="请选择">
            <el-option v-for="(i,k) in mallList" :key="k" :label="i.mallName" :value="i.token"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="快递公司" label-width="105px">
          <el-select v-model="params.快递公司" placeholder="请选择" clearable>
            <el-option v-for="(i,k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="打印时间" label-width="105px">
          <range-picker :date="[params.startDate, params.endDate]"
            @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
        </el-form-item>
        <el-form-item label="快速筛选" label-width="105px">
          <el-input v-model="params.快速筛选" placeholder="请输入订单号/运单号/批次号/手机号" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="address" label="批次号" min-width="200px" />
        <el-table-column prop="address" label="店铺" min-width="200px" />
        <el-table-column prop="address" label="订单号" min-width="200px" />
        <el-table-column prop="address" label="打印时间" min-width="200px" />
        <el-table-column prop="address" label="快递/运单号" min-width="200px" />
        <el-table-column prop="address" label="收件信息" min-width="200px" />
        <el-table-column prop="address" label="寄件信息" min-width="200px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      // api: require("@/api/sy/user").default,
      aliApi: {
        logistics: require('@/api/wx/logistics').default,
      },
      sysType: "",
      mallToken: "", //店铺Token
      params: {
        快递公司: "",
        startDate: null,
        endDate: null,
        快速筛选: "",
      },
      companiesList: [],
      mallList: [],
    };
  },
  created() {
    this.sysType = "ali"; //localStorage.getItem("sys_type");
    // this.mallList = JSON.parse(localStorage.getItem("mall_list"));
    // this.mallToken = localStorage.getItem("token");
    // this.getCompanies();
  },
  methods: {
    // onMallChange() {
    //   this.params.快递公司 = "";
    //   this.companiesList = [];
    //   this.getCompanies();
    // },
    // getCompanies() {
    //   return new Promise((resolve, reject) => {
    //     this[this.sysType + "Api"].logistics.companies(this.mallToken).then(res => {
    //       if (!res.errorCode) this.companiesList = res.data;
    //       resolve(res);
    //     }).catch((err) => { })
    //   })
    // },
    getDataFunc(params) {
      // params = this.$commonJs.obj.removeNullKey({
      //   ...params,
      //   OrderType: this.quickSearch,
      //   SnField: this.snField,
      //   SnType: this.snType,
      //   [this.params.fieldType]: this.params.fieldValue
      // })
      return new Promise((resolve, reject) => {
        console.log("获取数据");
        resolve({ Code: 0, data: [], Msg: null })
        // this.api.list(params).then(res => {
        //   console.log("getDataFunc", params)
        //   resolve(res)
        // })
      })
    },
  },
};
</script>